module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.cca62d2.woff";